import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';

import { Step4 } from '../../../graphql/generated/graphql';
import { useState, useEffect } from 'react';
import useMarkStepDone from './useMarkStepDone';
import { getAuthentication } from '../../../hooks/useAuthentication';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../../components/ui/use-toast';
import useOnBoardingPage from './useOnBoardingPage';
import { useForm } from 'react-hook-form';
import { fetchOnBoardingStep4, updateProfile } from '@/services/on-boarding/onboarding.service';

const schema = z.object({
  role: z.string({
    required_error: 'Please select a role.',
  }),
  ageBracket: z.string({
    required_error: 'Please select the age bracket.',
  }),
  gender: z.string({
    required_error: 'Please select the gender.',
  }),
  //   location: z.string({
  //     required_error: 'Please select the location.',
  //   }),
});

export type SchemaInput = z.infer<typeof schema>;

export function useOnBoardingStep4() {
  const router = useNavigate();
  const [response, setResponse] = useState<Step4>({} as Step4);

  const form = useForm({
    resolver: zodResolver(schema),
  });

  const { setValue, getValues, watch, control } = form;

  const { markStepDone, checkCurrentStep } = useMarkStepDone();
  const { toast } = useToast();
  const { page } = useOnBoardingPage();

  useEffect(() => {
    (async () => {
      checkCurrentStep();
      const result = await fetchOnBoardingStep4();
      setResponse(result as Step4);
    })();
  }, [checkCurrentStep]);

  const handleSubmit = async () => {
    const values = getValues();
    if (!values.gender) {
      toast({
        description: 'Please select the gender',
        variant: 'destructive',
      });
      return;
    }

    if (!values.role) {
      toast({
        description: 'Please select a role',
        variant: 'destructive',
      });
      return;
    }

    if (!values.ageBracket) {
      toast({
        description: 'Please select the age bracket',
        variant: 'destructive',
      });
      return;
    }

    // if (!values.location) {
    //   toast({
    //     description: 'Please select the location',
    //     variant: 'destructive',
    //   });
    //   return;
    // }

    const { user } = getAuthentication();
    if (!user) return;
    await updateProfile(user.id, values.role, values.gender, values.location, values.ageBracket);
    const nextUrl = response?.content?.button?.link || '#';
    markStepDone(nextUrl);
    router(nextUrl);
  };

  return {
    response,
    handleSubmit,
    page,
    setValue,
    watch,
    control,
    form,
  };
}
